package team.platforma.multiplatform_material_extension.text_input.style

import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.TextFieldColors
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object TextInput {
    private var mViewStyle: Style = Style.Outline
    private var mTextStyle: TextStyle? = null
    private var mShape: Shape? = null
    private var mColors: TextFieldColors? = null

    @Composable
    fun define(
        style: Style = Style.Outline,
        textStyle: TextStyle = LocalTextStyle.current,
        shape: Shape = when (style) {
            Style.Outline -> OutlinedTextFieldDefaults.shape
            Style.Filled -> TextFieldDefaults.shape
        },
        colors: TextFieldColors = when (style) {
            Style.Outline -> OutlinedTextFieldDefaults.colors()
            Style.Filled -> TextFieldDefaults.colors()
        }
    ) {
        mViewStyle = style
        mTextStyle = textStyle
        mShape = shape
        mColors = colors
    }

    fun viewStyle(): Style {
        return mViewStyle
    }

    enum class Style {
        Outline,
        Filled
    }

    @Composable
    fun shape(): Shape {
        return mShape ?: run {
            when (mViewStyle) {
                Style.Outline -> OutlinedTextFieldDefaults.shape
                Style.Filled -> TextFieldDefaults.shape
            }
        }
    }

    @Composable
    fun textStyle(): TextStyle {
        return mTextStyle ?: LocalTextStyle.current
    }

    @Composable
    fun colors(): TextFieldColors {
        return mColors ?: run {
            when (mViewStyle) {
                Style.Outline -> OutlinedTextFieldDefaults.colors()
                Style.Filled -> TextFieldDefaults.colors()
            }
        }
    }
}